import React from 'react';
import PropTypes from 'prop-types';
import * as AD_THEMES from '../../../shared/library/advert/themes';
import {GridItem} from '../components/shared/render';
import Advert from '../../../shared/library/advert';
import NavAnchor from '../components/shared/nav-anchor';
import Posts from '../components/posts';
import {flattenEdges} from '../../../shared/utils/graphql';
import AlternativesCard from '../../../shared/library/cards/alternatives';
import {NAVBAR_HEIGHT} from '../../../shared/style/dimensions';

const NAV_BAR_HEIGHT = 90;
const TOOL_CARD_STICKY_HEIGHT = 72;
const NAV_ANCHOR_OFFSET = NAV_BAR_HEIGHT + TOOL_CARD_STICKY_HEIGHT + NAVBAR_HEIGHT + 20;

const ExtraComponents2 = ({
  stackup,
  num,
  slug,
  contentGroup,
  adLayer,
  adCategory,
  adFunction,
  removeAfterCons,
  showPosts,
  removeAfterAlternatives,
  currentUser,
  showAlternativeTools,
  tools,
  privateMode,
  showTopContent,
  showBottomContent
}) => {
  return (
    <>
      {/* For time being hiding AD theme component, discussed with vamsee: https://trello.com/c/wASLkiWr */}
      {false && stackup && !privateMode && (
        <GridItem span={num}>
          <Advert
            placement="stackup"
            objectType="Stackup"
            objectId={slug}
            contentGroupPage={contentGroup}
            requestPath={stackup.path}
            layer={adLayer}
            category={adCategory}
            primaryFunction={adFunction}
            theme={AD_THEMES.ROW}
          />
        </GridItem>
      )}
      {removeAfterCons && (
        <>
          {stackup &&
            showPosts &&
            removeAfterAlternatives &&
            (!showTopContent && !showBottomContent) && (
              <GridItem span={num}>
                <NavAnchor id="posts" offset={NAV_ANCHOR_OFFSET} span={num} />
                <Posts slug={slug} currentUser={currentUser} />
              </GridItem>
            )}
          {showAlternativeTools && (
            <>
              <NavAnchor id="alternatives" offset={NAV_ANCHOR_OFFSET} span={num} />
              <GridItem span={num} style={{borderBottom: 'none'}}>
                <AlternativesCard
                  tools={tools}
                  title={stackup.title}
                  items={flattenEdges(stackup.cachedAlternativeTools)}
                />
              </GridItem>
            </>
          )}
        </>
      )}
    </>
  );
};

ExtraComponents2.propTypes = {
  num: PropTypes.number,
  tools: PropTypes.array,
  privateMode: PropTypes.any,
  stackup: PropTypes.object,
  slug: PropTypes.string,
  contentGroup: PropTypes.string,
  adLayer: PropTypes.any,
  adCategory: PropTypes.any,
  adFunction: PropTypes.any,
  removeAfterCons: PropTypes.bool,
  showPosts: PropTypes.bool,
  removeAfterAlternatives: PropTypes.bool,
  currentUser: PropTypes.any,
  showAlternativeTools: PropTypes.bool,
  showTopContent: PropTypes.bool,
  showBottomContent: PropTypes.bool
};

export default ExtraComponents2;
